import { deleteCookie } from 'cookies-next';

export const TOKEN_COOKIE = 'ath-chat-api-token';

export const deleteTokenCookie = () => {
  deleteCookie(TOKEN_COOKIE);
};
